<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Edit Gadai Elektronik</h5>
            </template>
            <b-alert variant="primary" show>* Sedang dalam verifikasi AM</b-alert>
            <b-form @submit.prevent="openModalConfirm">
                <div class="detail-data-wrapper mb-4">
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label"><strong>No. Faktur</strong></b-col>
                        <b-col v-if="dataStagingElek.noFaktur != null"><strong>{{ dataStagingElek.noFaktur }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Status Gadai</b-col>
                        <b-col v-if="dataStagingElek.statusGadai != null">{{ dataStagingElek.statusGadai }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA ANGGOTA</h6>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Anggota</b-col>
                        <b-col v-if="dataStagingElek.anggota.noAnggota != null"><strong>{{ dataStagingElek.anggota.noAnggota }}</strong></b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Jenis Identitas</b-col>
                        <b-col v-if="dataStagingElek.anggota.jenisIdentitas != null">{{ dataStagingElek.anggota.jenisIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Identitas</b-col>
                        <b-col v-if="dataStagingElek.anggota.noIdentitas != null">{{ dataStagingElek.anggota.noIdentitas }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Nama</b-col>
                        <b-col v-if="dataStagingElek.anggota.namaAnggota != null">{{ dataStagingElek.anggota.namaAnggota }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">Alamat</b-col>
                        <b-col v-if="dataStagingElek.anggota.alamat != null">{{ dataStagingElek.anggota.alamat }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col cols="4" class="detail-data-label">No. Handphone</b-col>
                        <b-col v-if="dataStagingElek.anggota.noHp != null">{{ dataStagingElek.anggota.noHp }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA BARANG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataStagingElek.barangLama.jenis.name != null">{{ dataStagingElek.barangLama.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataStagingElek.barangLama.merk.name != null">{{ dataStagingElek.barangLama.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataStagingElek.barangLama.tipe.name != null">{{ dataStagingElek.barangLama.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun / Generasi</div>
                                <div v-if="dataStagingElek.barangLama.tahun != null">{{ dataStagingElek.barangLama.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataStagingElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">Spesifikasi Laptop</div>
                                <div>{{ dataStagingElek.barangLama.laptop.spesifikasiLaptop }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataStagingElek.barangLama.gradeKondisi.name != null">{{ dataStagingElek.barangLama.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataStagingElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">RAM Laptop</div>
                                <div>{{ dataStagingElek.barangLama.laptop.ram }} GB</div>
                            </div>
                            <div v-if="dataStagingElek.barangLama.laptop != null" class="mb-2">
                                <div class="detail-data-label">Hardisk Laptop</div>
                                <div>{{ dataStagingElek.barangLama.laptop.gadaiJenisHardisk }} {{ dataStagingElek.barangLama.laptop.gadaiSizeHardisk }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Imei/ SN</div>
                                <div v-if="dataStagingElek.barangLama.noImei != null">{{ dataStagingElek.barangLama.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Password</div>
                                <div v-if="dataStagingElek.barangLama.password != null">{{ dataStagingElek.barangLama.password }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataStagingElek.barangLama.warna.name != null">{{ dataStagingElek.barangLama.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataStagingElek.barangLama.keterangan != null && dataStagingElek.barangLama.keterangan != 'null'">{{ dataStagingElek.barangLama.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataStagingElek.barangLama.kelengkapan.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataStagingElek.barangLama.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataStagingElek.barangLama.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingElek.barangLama.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Jenis Barang</div>
                                <div v-if="dataStagingElek.barangBaru.jenis.name != null">{{ dataStagingElek.barangBaru.jenis.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Merk Barang</div>
                                <div v-if="dataStagingElek.barangBaru.merk.name != null">{{ dataStagingElek.barangBaru.merk.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tipe Barang</div>
                                <div v-if="dataStagingElek.barangBaru.tipe.name != null">{{ dataStagingElek.barangBaru.tipe.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Tahun / Generasi</div>
                                <div v-if="dataStagingElek.barangBaru.tahun != null">{{ dataStagingElek.barangBaru.tahun }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataStagingElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">Spesifikasi Laptop</div>
                                <div>{{ dataStagingElek.barangBaru.laptop.spesifikasiLaptop }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi / Grade Barang</div>
                                <div v-if="dataStagingElek.barangBaru.gradeKondisi.name != null">{{ dataStagingElek.barangBaru.gradeKondisi.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div v-if="dataStagingElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">RAM Laptop</div>
                                <div>{{ dataStagingElek.barangBaru.laptop.ram }} GB</div>
                            </div>
                            <div v-if="dataStagingElek.barangBaru.laptop != null" class="mb-2">
                                <div class="detail-data-label">Hardisk Laptop</div>
                                <div>{{ dataStagingElek.barangBaru.laptop.gadaiJenisHardisk }} {{ dataStagingElek.barangBaru.laptop.gadaiSizeHardisk }}</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">No. Imei/ SN</div>
                                <div v-if="dataStagingElek.barangBaru.noImei != null">{{ dataStagingElek.barangBaru.noImei }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Password</div>
                                <div v-if="dataStagingElek.barangBaru.password != null">{{ dataStagingElek.barangBaru.password }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Warna</div>
                                <div v-if="dataStagingElek.barangBaru.warna.name != null">{{ dataStagingElek.barangBaru.warna.name }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kondisi/ Kerusakan/ Keterangan Lainnya</div>
                                <div v-if="dataStagingElek.barangBaru.keterangan != null && dataStagingElek.barangBaru.keterangan != 'null'">{{ dataStagingElek.barangBaru.keterangan }}</div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Kelengkapan Barang</div>
                                <div v-if="dataStagingElek.barangBaru.kelengkapan.length >= 1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="item in dataStagingElek.barangBaru.kelengkapan"  v-bind:key="item">
                                            {{ item }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                            <div class="mb-2">
                                <div class="detail-data-label">Spesifikasi Barang</div>
                                <div v-if="dataStagingElek.barangBaru.spesifikasi.length >=1">
                                    <ul class="list-circle-wrapper">
                                        <li v-for="(item, idx) in dataStagingElek.barangBaru.spesifikasi"  v-bind:key="idx">
                                            {{ item.name }}
                                        </li>
                                    </ul>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">DATA PENDUKUNG</h6>
                    <b-row>
                        <b-col lg="4" md="6" cols="6">
                            <h6 class="compare-text-title">Data Sekarang</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingElek.fotoLama)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingElek.fotoLama"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                                <div v-else>-</div>
                            </div>
                        </b-col>
                        <b-col lg="4" md="6" cols="6" class="comparison-separator">
                            <h6 class="compare-text-title">Data Perubahan</h6>
                            <div class="mb-2">
                                <div class="detail-data-label">Foto</div>
                                <div v-if="$helper.isNotNullAndNotEmpty(dataStagingElek.fotoBaru)">
                                    <span class="mr-1" v-for="(item, idx) in dataStagingElek.fotoBaru"  v-bind:key="idx">
                                        <a v-bind:href="item.name" target="_blank">
                                            <img width="150px" :src="item.name" alt="Foto Pendukung">
                                        </a>
                                    </span>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
                <div class="detail-data-wrapper mb-4">
                    <h6 class="form-title">ALASAN PERUBAHAN</h6>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Keterangan</b-col>
                        <b-col v-if="dataStagingElek.keterangan != null">{{ dataStagingElek.keterangan }}</b-col>
                        <b-col v-else>-</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan pada</b-col>
                        <b-col>{{ $helper.changeDateFormat(dataStagingElek.createdAt )}} {{ $helper.changeDateFormatGetHour(dataStagingElek.createdAt )}}</b-col>
                    </b-row>
                    <b-row class="mb-2">
                        <b-col lg="4" md="6" cols="6" class="detail-data-label">Diajukan oleh</b-col>
                        <b-col>{{ dataStagingElek.createdBy }}</b-col>
                    </b-row>
                </div>
            </b-form>
        </b-card>
    </div>
</template>

<script>

export default {
    name: 'edit-gadai-elektronik',
    data(){
        return{
            initStatus: 0,
            dataStagingElek: []
        }
    }, 
    methods: {

        //----------------- Fungsi Inisialisasi -----------------

        init(){
            this.initStatus = 0
            this.id = this.$route.params.id
            
            let getEditStagingElek = this.$axios.get(`gadai/daftar-gadai/${this.id}/staging`).then(response => {
                this.dataStagingElek = response.data
        
                let msg = this.$helper.getFlash()
                this.$helper.toastSucc(this, msg)
            })

            Promise.all([getEditStagingElek]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                const noFaktur = this.$route.path.split('/')[3];
                const message = this.$helper.parseError(this, error, '', false)
                if (message == 'Gadai ini tidak dalam verifikasi edit - tidak dapat menampilkan data!') {
                    this.$router.push(`/gadai/inquiry-faktur/${noFaktur}`);
                }
                this.initStatus = -1
            })
        },

        
    },
    created(){
        this.init()
    }
}
</script>
